import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
} from "../../APIHelpers/Responses";

export const sharedServices = {
  shareItemMultiGroup,
  revokedSharedItemGroup,
  deleteSharedItemGroup,
  getSharedItemGroupList,

  shareGroupInternalUser,
  getSharedWithMeGroupList,
  getSharedByMeGroupList,
  revokedSharedGroup,
  deleteSharedGroup,
  getSharedGroupList,

  shareItemInternalUser,
  revokedSharedItem,
  deleteSharedItem,
  getSharedItemList,
};

// Share Item Multi Group
async function shareItemMultiGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}shareItemMultiGroup`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Rekove Shared Item Multi Group
async function revokedSharedItemGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}revokedSharedItemGroup`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Shared Multi Group
async function deleteSharedItemGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteSharedItemGroup`,
    headersWithAuth("DELETE", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Shared Multi Group
async function getSharedItemGroupList(auth, itemId, page, length) {
  try {
    const signal = cancelPreviousRequest(`getSharedItemGroupList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getSharedItemGroupList/${itemId}?&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getSharedItemGroupList/${itemId}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Share Group For Internal User
async function shareGroupInternalUser(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}shareGroupInternalUser`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Shared With Me Group List
async function getSharedWithMeGroupList(auth) {
  try {
    const signal = cancelPreviousRequest("getSharedWithMeGroupList");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSharedWithMeGroupList`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Shared By Me Group List
async function getSharedByMeGroupList(auth) {
  try {
    const signal = cancelPreviousRequest("getSharedByMeGroupList");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSharedByMeGroupList`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Rekove Shared Group
async function revokedSharedGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}revokedSharedGroup`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Shared Group
async function deleteSharedGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteSharedGroup`,
    headersWithAuth("DELETE", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Shared Group
async function getSharedGroupList(auth, itemId, page, length) {
  try {
    const signal = cancelPreviousRequest(`getSharedGroupList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getSharedGroupList/${itemId}?&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getSharedGroupList/${itemId}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Share Item For Internal User
async function shareItemInternalUser(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}shareItemInternalUser`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}

// Update Shared Status
async function revokedSharedItem(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}revokedSharedItem`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Shared
async function deleteSharedItem(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteSharedItem`,
    headersWithAuth("DELETE", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Shared
async function getSharedItemList(auth, itemId, page, length) {
  try {
    const signal = cancelPreviousRequest(`getSharedItemList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getSharedItemList/${itemId}?&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getSharedItemList/${itemId}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}